export const GET_TEMPLATE_LIST = 'GET_TEMPLATE_LIST';
export const SET_TEMPLATE_LIST = 'SET_TEMPLATE_LIST';
export const GET_TEMPLATE_LIST_FAILURE = 'GET_TEMPLATE_LIST_FAILURE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';
export const ON_SAVE = 'ON_SAVE';
export const ON_SAVE_SUCCESS = 'ON_SAVE_SUCCESS';
export const UPSERT_TEMPLATE = 'UPSERT_TEMPLATE';

export const getTemplateList = (token) => ({
  type: GET_TEMPLATE_LIST,
  payload: { token },
});

export const setTemplateList = (templates) => ({
  type: SET_TEMPLATE_LIST,
  payload: templates,
});

export const getTemplateListFailure = (error) => ({
  type: GET_TEMPLATE_LIST_FAILURE,
  payload: error,
});

export const deleteTemplate = (token, rowData) => ({
  type: DELETE_TEMPLATE,
  payload: { token, rowData },
});

export const deleteTemplateSuccess = (id) => ({
  type: DELETE_TEMPLATE_SUCCESS,
  payload: id,
});

export const onSave = (token, postData, successCallback) => ({
  type: ON_SAVE,
  payload: { token, postData, successCallback },
});

export const onSaveSuccess = () => ({
  type: ON_SAVE_SUCCESS,
});

export const upsertTemplate = (template) => ({
  type: UPSERT_TEMPLATE,
  payload: template,
});
